import React, {Component} from "react";
import './menu/menu.css';
import {withRouter} from "react-router";
import manifesto from "../Resources/Videos Manifiesto/MAIN Reedit SP_low.mp4";
import manifesto_en from "../Resources/Videos Manifiesto/MAIN Reedit EN_low.mp4";
import manifesto_pt from "../Resources/Videos Manifiesto/MAIN Reedit PT_low.mp4";
import portrait_manifesto from "../Resources/Videos Manifiesto/manifiesto_portrait_es.mp4";
import portrait_manifesto_en from "../Resources/Videos Manifiesto/manifiesto_portrait_en.mp4";
import portrait_manifesto_pt from "../Resources/Videos Manifiesto/manifiesto_portrait_pt.mp4";
import {LanguageContext} from "../Utilities/LanguageContext";
import {isPortrait} from "../Utilities/utils";
import {isMobile} from "react-device-detect";

class VideoPlayer extends Component {
    static contextType = LanguageContext

    componentDidMount() {
        var elem = document.getElementById("video");
        console.log(elem.mozRequestFullscreen)
        console.log(elem.webkitRequestFullscreen)
        console.log(elem.msRequestFullscreen)
        if (elem.mozRequestFullscreen) {
            elem.mozRequestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen();
        }
    }

    getVideo() {
        return <video  width="100%"  className={'videobg'} id={'video'} autoPlay controls onEnded={() => {
            document.getElementById('video').play()
            //this.props.amplitude.logEvent('manifesto_video_ended')
        }}>
            {
                isMobile ?
                    <source src={this.context.i18nConfig.locale === "pt" ? portrait_manifesto_pt :
                        this.context.i18nConfig.locale === "en" ? portrait_manifesto_en :
                            portrait_manifesto} type="video/mp4" />
                    :
                    <source src={this.context.i18nConfig.locale === "pt" ? manifesto_pt :
                        this.context.i18nConfig.locale === "en" ? manifesto_en :
                            manifesto} type="video/mp4"/>

            }
        </video>
    }

    render() {
        return <section id={"menu"} className={'main-menu'}>
            <div className={'fixed-menu'}>
                <div className="menu-icons-container close-video-container clickable"
                     onClick={() => this.props.history.goBack()}/>
            </div>
            <div className="videobg">
                {this.getVideo()}
                {}
            </div>
        </section>
    }
}

export default withRouter(VideoPlayer);